import ManageContent from './manage-content'
export default ManageContent
